import { render } from "./MyAccountMenu.vue?vue&type=template&id=3471e309&scoped=true&lang=pug"
import script from "./MyAccountMenu.vue?vue&type=script&lang=ts"
export * from "./MyAccountMenu.vue?vue&type=script&lang=ts"

import "./MyAccountMenu.vue?vue&type=style&index=0&id=3471e309&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3471e309"

export default script